import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionAriaLabel: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.sectionAriaLabel',
    description: 'Label for a sidebar card with section naming',
    defaultMessage: 'Review status',
  },
  headingAriaLabel: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.headingAriaLabel',
    description:
      'Label for a sidebar heading card showing a list reviewers and their statuses.',
    defaultMessage:
      '{reviewersCount} {reviewersCount, plural, one {reviewer} other {reviewers}}, {approvalsCount} {approvalsCount, plural, one {approval} other {approvals}}',
  },
  reviewerCount: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.reviewerCount',
    description:
      'Label for displaying the number of reviewers related to this pull request.',
    defaultMessage:
      '{total, plural, one {{formattedCount} reviewer} other {{formattedCount} reviewers}}',
  },
  approvalsCount: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.approvalsCount',
    description:
      'Label for displaying the number of approvals related to this pull request.',
    defaultMessage:
      '{approvalsCount, plural, one {{approvalsCount} approval} other {{approvalsCount} approvals}}',
  },
  approved: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.approved',
    description: 'Label for a approved icon.',
    defaultMessage: 'Approved',
  },
  changesRequested: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.changesRequested',
    description: 'Label for a changes requested icon.',
    defaultMessage: 'Changes requested',
  },
  removeReviewer: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.removeReviewer',
    description: 'Label for a remove reviewer button.',
    defaultMessage: 'Remove reviewer',
  },
  addReviewer: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.addReviewer',
    description: 'Label for an add reviewer button.',
    defaultMessage: 'Add reviewer',
  },
  reviewersSearchPlaceholder: {
    id: 'frontbucket.repository.pullRequest.reviewerStatusesCard.reviewersSearchPlaceholder',
    description: 'Placeholder for an add reviewer button.',
    defaultMessage: 'Add reviewer',
  },
});
